import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { setParams } from '../../../../core/config/core.httpclient-utils';

import { TrackeritemRest } from '../../services/trackeritem.rest'
import { UiService } from '../../../../core/services/core.ui.service';
import { NotificationService } from '../../../../core/services/core.notification.service';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-duplicates',
  template: require('./duplicates.component.html')
})
export class DuplicatesComponent implements OnInit {
  @Input() trackeritem: any;
  @Input() allowUpdates: any;

  duplicates: any[];
  addDuplicate: {
    searchItemsResult: any[],
    search: string,
    searching: boolean,
    autoSubmitTimer: any
  };
  markedForDeletion: number;

  constructor(
	private httpClient: HttpClient, 
	private trackeritemRest: TrackeritemRest,
	private uiService: UiService,
	private notificationService: NotificationService,
	private translateService: GfTranslateService,
	private stateService: StateService
  ) { }

  ngOnInit(): void {
    this.duplicates = _.map(_.get(this.trackeritem, 'rel.duplicates.duplicatedBy', []), 
      (item: any) => {    
        return {
          id: item.id,
          title: '[#]' + item.id + '] ' + item.summary
        };
      });
    this.addDuplicate = {
      searchItemsResult: [],
      search: '',
      searching: false,
      autoSubmitTimer: null
    };
    this.markedForDeletion = 0;
  }

  goTo(stateName: any, params?: any) {
	this.stateService.go(stateName, params);
  }

  saveDuplicate(duplicateTi: any): void {
    this.addDuplicate.search = '';
    this.addDuplicate.searchItemsResult = [];

    const params = {
      tid: duplicateTi.refId,
      duplicateOfTid: this.trackeritem.id
    };

    // Assuming TrackeritemRest is an Angular service handling HTTP requests
    this.trackeritemRest.postDuplicate(this.trackeritem.id, params)
    .then(() => {
        this.duplicates.push({
          id: duplicateTi.refId,
          title: duplicateTi.title
        });
        this.notifyDuplicates();
      },
      (err) => {
        this.uiService.message.showError(this.translateService.translate("There was an error trying to remove the duplciate"));
    });
  }

  addDuplicateForAutoSubmit(searchValue: string): void {
    if (this.addDuplicate.autoSubmitTimer) {
      clearTimeout(this.addDuplicate.autoSubmitTimer);
    }
    this.addDuplicate.autoSubmitTimer = setTimeout(() => {
      this.addDuplicatesForSearchItems(searchValue);
    }, 750);
  }

  addDuplicatesForSearchItems(searchValue: string): void {
    this.addDuplicate.searchItemsResult = [];

    if (searchValue.length < 3) {
      this.addDuplicate.searching = false;
      return;
    }

    this.addDuplicate.searching = true;

    const params = {
      q: searchValue,
      s: 'trackeritem',
      //project: this.project.id,
      page_num: 1,
      page_size: 20
    };

    this.httpClient.get('/api/search/', { params: setParams(params) })
	.toPromise()
	.then((response: any) => {
	  const items = response.items;
	  this.addDuplicate.searchItemsResult = items.sort((a, b) => b.matchScore - a.matchScore);
	})
	.catch(error => {
	  // Handle error
	  return [];
	})
	.finally(() => {
	  this.addDuplicate.searching = false;
	});
  }

  removeDuplicate(item: any): void {
    if (this.markedForDeletion !== item.id) {
      this.markedForDeletion = item.id;
      return;
    }

    this.trackeritemRest.deleteDuplicate(item.id, this.trackeritem.id)
      .then(() => {
        this.duplicates = this.duplicates.filter(dup => dup.id !== item.id);
        this.notifyDuplicates();
        this.uiService.message.showSuccess(this.translateService.translate("The duplicate has been removed"));
      },
      (err) => {
        this.uiService.message.showError(this.translateService.translate("There was an error trying to remove the duplciate"));
      });
  }

  notifyDuplicates(): void {
    this.notificationService.notifyAll('TRACKER.ITEM.EDIT.DUPLICATES.UPDATE', this.duplicates);
  }
}
